import React, { useContext, useEffect } from 'react';
import appContext from '../../../../context/app/appContext';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import themeContext from '../../../../context/theme/themeContext';
import ASSETS from '../../../../config/constants/assets.json';
import ARBITRUM_ASSETS from '../../../../config/constants/arbitrumAssets.json';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../../../config/constants';

const SpoolAsset: React.FC = () => {
    const { selectedAsset, setSelectedAsset, setStepCompletedStatus } =
        useContext(CreateASpoolContext);
    const { sdk, interfaceSDK, getRiskModels } = useContext(appContext);
    const { chainId } = useWeb3React();

    const { theme } = useContext(themeContext);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedAsset(e.target.value);
    };

    useEffect(() => {
        getRiskModels();
        // if (sdk && interfaceSDK) {
        // getRiskModels();
        // }
    }, [sdk, interfaceSDK, chainId, getRiskModels]);

    useEffect(() => {
        if (selectedAsset) {
            setStepCompletedStatus(1, true);

            return;
        }

        setStepCompletedStatus(1, false);
    }, [selectedAsset, setStepCompletedStatus]);

    return (
        <div className={`spool-asset ${theme}`}>
            <span>Select your Spool's deposit currency.</span>
            {Object.entries(
                chainId === SupportedChains.ARBITRUM_ONE ? ARBITRUM_ASSETS : ASSETS
            ).map(([address, label]) => (
                <label key={label} className={address === selectedAsset ? 'active' : ''}>
                    <input
                        type='radio'
                        name='asset'
                        value={address}
                        onChange={handleChange}
                        checked={address === selectedAsset}
                    />
                    <span>{label} (ERC20)</span>
                </label>
            ))}
        </div>
    );
};

export default SpoolAsset;
